module.exports = __webpack_public_path__ + "static/media/icon-documentacion.1bd4bede.svg";